export const getBreedOptions = (t) => [
	{ value: 'angus', label: t('admin.animal.breed_angus') },
	{ value: 'alistana-sanabresa', label: t('admin.animal.breed_alistana-sanabresa') },
	{ value: 'asturiana_de_la_montana', label: t('admin.animal.breed_asturiana_de_la_montana') },
	{ value: 'asturiana_de_los_valles', label: t('admin.animal.breed_asturiana_de_los_valles') },
	{ value: 'avilena-Negra_iberica', label: t('admin.animal.breed_avilena-Negra_iberica') },
	{ value: 'berrenda_en_colorado', label: t('admin.animal.breed_berrenda_en_colorado') },
	{ value: 'berrenda_en_negro', label: t('admin.animal.breed_berrenda_en_negro') },
	{ value: 'blanca_cacerena', label: t('admin.animal.breed_blanca_cacerena') },
	{ value: 'blonda_de_aquitania', label: t('admin.animal.breed_blonda_de_aquitania') },
	{ value: 'canaria', label: t('admin.animal.breed_canaria') },
	{ value: 'cardena_andaluza', label: t('admin.animal.breed_cardena_andaluza') },
	{ value: 'charolais', label: t('admin.animal.breed_charolais') },
	{ value: 'fleckvieh-simmental', label: t('admin.animal.breed_fleckvieh-simmental') },
	{ value: 'frisona', label: t('admin.animal.breed_frisona') },
	{ value: 'lidia', label: t('admin.animal.breed_lidia') },
	{ value: 'limusin', label: t('admin.animal.breed_limusin') },
	{ value: 'marismeno', label: t('admin.animal.breed_marismeno') },
	{ value: 'monchina', label: t('admin.animal.breed_monchina') },
	{ value: 'morucha', label: t('admin.animal.breed_morucha') },
	{ value: 'negra_andaluza', label: t('admin.animal.breed_negra_andaluza') },
	{ value: 'pajuna', label: t('admin.animal.breed_pajuna') },
	{ value: 'palmera', label: t('admin.animal.breed_palmera') },
	{ value: 'parda', label: t('admin.animal.breed_parda') },
	{ value: 'parda_de_montana', label: t('admin.animal.breed_parda_de_montana') },
	{ value: 'pirenaica', label: t('admin.animal.breed_pirenaica') },
	{ value: 'retinta', label: t('admin.animal.breed_retinta') },
	{ value: 'rubia_gallega', label: t('admin.animal.breed_rubia_gallega') },
	{ value: 'salers', label: t('admin.animal.breed_salers') },
	{ value: 'sayaguesa', label: t('admin.animal.breed_sayaguesa') },
	{ value: 'serrana_de_teruel', label: t('admin.animal.breed_serrana_de_teruel') },
	{ value: 'terrena_de_euskadi', label: t('admin.animal.breed_terrena_de_euskadi') },
	{ value: 'tudanca', label: t('admin.animal.breed_tudanca') },
	{ value: 'other', label: t('admin.animal.breed_other') }
]